<template>
  <el-container v-loading.fullscreen="loading"
                element-loading-text="加载中"
                style="background-color:#ffffff;">
    <el-header height="50px"
               class="kye-header-panel">
      <header-top></header-top>
    </el-header>
    <el-container :style="{height: asideHeight, maxHeight: asideHeight}">
      <el-aside :width="`${menuWidth}px`"
                class="kye-aside-panel"
                style="overflow-y:hidden;">
        <sidebar :width="menuWidth"
                 @switch-menu="switchMenu"></sidebar>
      </el-aside>
      <navbar :paddingLeft="menuWidth"></navbar>
      <el-main
        class="main-panel"
        :style="mainPanelStyle"
        ref="main">
        <keep-alive :include="cachedViews">
          <router-view></router-view>
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import axios from 'axios'
  import { REST, APPKEY } from 'public/config'
  import { defineFreezeProperty, getToken, md5Http, createWatermarkStyle } from 'public/utils'
  import { throttle } from 'lodash'
  import browser from './setup/check-browser'
  import HeaderTop from './header.vue'
  import Sidebar from './sidebar.vue'
  import Navbar from './navbar.vue'
  import websocket from './websocket'

  export default {
    name: 'App',
    components: { HeaderTop, Sidebar, Navbar },
    data () {
      return {
        menuWidth: 160,
        asideHeight: '0',
      }
    },
    created () {
      this.mouseXY = ''
      this.oldMouseXY = ''
      this.addViewTags(this.$route)
      setInterval(this.handleToken, 5 * 60 * 1000)
      setInterval(this.refreshWaterMark, 5 * 60 * 1000)
    },
    mounted () {
      this.showViewportScaleTips()
      this.setAsideHeight()
      this.checkBrowser()
      this.resizeEvent = throttle(this.handleResize, 16)
      window.addEventListener('resize', this.resizeEvent)
      window.addEventListener('keydown', this.keydownEvent)
      window.addEventListener('mousemove', this.mouseMoveEvent)
      this.scrollEvent = throttle(this.handleScroll, 16)
      this.$refs.main.$el.addEventListener('scroll', this.scrollEvent)
      this.$bus.$once('APP_LOADED', this.init)
      this.$bus.$on('APP_LOADED', this.onAppLoaded)
      this.$bus.$on('WEBSOCKET_PING', this.websocketPing)
    },
    beforeDestroy () {
      window.removeEventListener('mousemove', this.mouseMoveEvent)
      window.removeEventListener('keydown', this.keydownEvent)
      window.removeEventListener('resize', this.resizeEvent)
      this.$refs.main.$el.removeEventListener('scroll', this.scrollEvent)
      this.$bus.$off('WEBSOCKET_PING', this.websocketPing)
    },
    computed: {
      cachedViews () {
        return this.$store.state.tagsView.cachedViews
      },
      loading () {
        return this.$store.state.loading
      },
      mainPanelStyle () {
        const { mainBackground } = this.$route.meta
        if (!mainBackground) {
          return null
        }
        return `background: ${mainBackground}`
      }
    },
    watch: {
      $route (val) {
        this.addViewTags(val)
        this.hideElPopper()
        this.refreshWaterMark()
        this.$bus.$emit('SET_SYSTEM_NAME')
      }
    },
    methods: {
      refreshWaterMark() {
        createWatermarkStyle(window.__ERPUSER__, +localStorage.svgFilter || 1)
      },
      setAsideHeight () {
        this.asideHeight = (window.innerHeight - 51) + 'px'
      },
      switchMenu (width) {
        this.menuWidth = width
      },
      handleResize () {
        this.setAsideHeight()
        this.$bus.$emit('GLOBAL_RESIZE')
      },
      handleScroll (e) {
        this.$bus.$emit('GLOBAL_SCROLL', e.target)
      },
      addViewTags (route) {
        if (route.name) {
          // 设置当前路由渲染的组件的名字和当前路由的名字相同
          // 保证 keep-alive 的 include 能够正确识别是否缓存组件
          let cpt = this.$router.getMatchedComponents()[1]
          cpt && (cpt._Ctor[0].options.name = route.name)
        }
        this.$store.dispatch('addVisitedViews', route)
      },
      hideElPopper () {
        let elArr = document.querySelectorAll('.el-picker-panel:not([style*="display: none"])')
        elArr.forEach(v => v.style.display = 'none')
        elArr = document.querySelectorAll('.el-select-dropdown:not([style*="display: none"])')
        elArr.forEach(v => v.style.display = 'none')
        elArr = document.querySelectorAll('.el-cascader-menus:not([style*="display: none"])')
        elArr.forEach(v => v.style.display = 'none')
      },
      keydownEvent (e) {
        let tag = this.$route.meta.tag
        if (e.keyCode === 27 && tag && tag !== this.$route.path && !this.$route.meta.escape) {
          // 按下 ESC 键，走searchPage的goBack返回逻辑
          // 混入了 route-hook 的新增、编辑页面，如果当前已弹出确认提示框，则需要屏蔽“ESC键切换路由”
          if (
            !document.querySelector('.el-message-box__wrapper:not([style*="display: none"])') &&
            !document.querySelector('.main-panel .kye-dialog__modal-in-tab:not([style*="display: none"])') &&
            !document.querySelector('body > .el-dialog__wrapper:not([style*="display: none"])')
          ) {
            const searchPageEl = document.querySelector('.kye-search-pager:not([style*="display: none"])')
            const searchPageInstance = searchPageEl && searchPageEl.__vue__
            if (searchPageInstance) {
              searchPageInstance.goBack()
            } else {
              this.$router.replace(tag)
            }
          }
        } else if (e.keyCode === 48 && (e.ctrlKey || e.metaKey) && this.scaleNotify) {
          // 按下 Ctrl+0 键，关闭缩提示
          this.scaleNotify.close()
        }
      },
      mouseMoveEvent (e) {
        this.mouseXY = `${e.x},${e.y}`
      },
      isViewportScale () {
        // 平板不检查浏览器缩放
        if ('ontouchstart' in window) {
          return false
        }
        return window.getComputedStyle(document.body).fontSize !== '12px' ||
          Math.abs(window.outerWidth - window.innerWidth) > 4
      },
      showViewportScaleTips () {
        if (this.isViewportScale()) {
          const key = navigator.platform.includes('Mac') ? '⌘+0' : 'Ctrl+0'
          this.scaleNotify = this.$notify.warning({
            title: '温馨提示',
            duration: 3600,
            offset: 64,
            dangerouslyUseHTMLString: true,
            message: `您的浏览器目前处于缩放状态，页面可能会出现错位现象，建议100%大小显示。<br/>按下 ${key} 可恢复正常`
          })
        }
      },
      handleToken () {
        if (this.mouseXY !== this.oldMouseXY) {
          this.oldMouseXY = this.mouseXY
          let token = getToken()
          let now = Date.now()
          let data = { access_token: token }
          axios({
            method: 'post',
            url: `${REST}?cas.authorize.getUserInfoByToken`,
            data,
            headers: {
              format: 'JSON',
              method: 'cas.authorize.getUserInfoByToken',
              appkey: APPKEY['cas'],
              token,
              timestamp: now,
              sign: md5Http(token, now, data)
            }
          })
        }
      },
      init () {
        // 增加一个已登录的标识。给订阅不到APP_LOADED事件的场景使用
        window.__APP_LOADED__ = true
        // 远程组件
        // 有 vtsIm 权限
        const permission = this.$store.state.permission.menus
        if (permission.includes('BToTCb3r-ut-')) {
          new Promise(window.__ERP_REMOTE_IMPORT__('vts/vtsIm')).then(console.log)
        }
        // vms 的费用预警
        new Promise(window.__ERP_REMOTE_IMPORT__('vms/vmsFeeSettingWarningPush')).then(console.log)
        // kyetree 大数据中心-智能计算平台 越精灵浮窗
        new Promise(window.__ERP_REMOTE_IMPORT__('kyetree/bigdataAiInsightYElf')).then(console.log)

        let home = this.$store.getters.menus['/']
        if (home && this.$route.path === '/') {
          defineFreezeProperty(window, '__ERPMODULE__', JSON.parse(JSON.stringify(home)))
        }
        // 模拟用户点击咨询解答，加载插件
        let answerDom = document.querySelector('.crmwas-answer-plugin-tool')
        if (answerDom) {
          answerDom.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, clientX: 0, clientY: 0 }))
        }
        // 模拟用户点击工单，加载插件
        let dom = document.querySelector('.kts-gd-plugin-tool')
        if (dom) {
          dom.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, clientX: 0, clientY: 0 }))
        }
      },
      onAppLoaded () {
        // 重新登录功能，页面未重新加载，导致实例多次创建
        if (this.websocket) {
          this.websocket.close()
          this.websocket = null
        }
        /* eslint-disable-next-line */
        this.websocket = new websocket(this, getToken())
      },
      websocketPing() {
        if (document.visibilityState === 'visible') {
          if (this.websocket) {
            console.log('执行ping')
            this.websocket.ping()
          }
        }
      },
      checkBrowser () {
        if (browser.isupdate) {
          this.$notify({
            title: '浏览器版本过低警告',
            duration: 0,
            type: 'error',
            offset: 64,
            dangerouslyUseHTMLString: true,
            message: `<p style="font-size: 14px;font-weight: 500;cursor: pointer;">您的浏览器版本过低，会影响铸剑的使用，请马上升级（点击下载）</p>`,
            onClick: _ => {
              window.__intercept__ = 0
              location.href = '/static/browser.html?browser=' + browser.browser
            }
          })
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/layout/layout/index.vue